"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var meta = {
  field_defs: {
    type: {
      input: {
        label: null,
        type: "select",
        required: true,
        array: false,
        pattern: null,
        disabled: false,
        "default": "article",
        options: {
          groups: [{
            id: "primary",
            text: "Primary"
          }],
          values: [{
            id: "radio_broadcast",
            text: "Radio Broadcast",
            group: "primary"
          }, {
            id: "dictionary_entry",
            text: "Dictionary Entry",
            group: "primary"
          }, {
            id: "encyclopedia_article",
            text: "Encyclopedia Article",
            group: "primary"
          }, {
            id: "manuscript",
            text: "Manuscript",
            group: "primary"
          }, {
            id: "email",
            text: "E-Mail",
            group: "primary"
          }, {
            id: "instant_message",
            text: "Instant Message",
            group: "primary"
          }, {
            id: "letter",
            text: "Letter",
            group: "primary"
          }, {
            id: "forum_post",
            text: "Forum Post",
            group: "primary"
          }, {
            id: "blog_post",
            text: "Blog Post",
            group: "primary"
          }, {
            id: "artwork",
            text: "Artwork",
            group: "primary"
          }, {
            id: "audio_recording",
            text: "Audio Recording",
            group: "primary"
          }, {
            id: "bill",
            text: "Bill",
            group: "primary"
          }, {
            id: "book",
            text: "Book",
            group: "primary"
          }, {
            id: "book_section",
            text: "Book Section",
            group: "primary"
          }, {
            id: "case",
            text: "Case",
            group: "primary"
          }, {
            id: "computer_program",
            text: "Computer Program",
            group: "primary"
          }, {
            id: "conference_paper",
            text: "Conference Paper",
            group: "primary"
          }, {
            id: "document",
            text: "Document",
            group: "primary"
          }, {
            id: "film",
            text: "Film",
            group: "primary"
          }, {
            id: "hearing",
            text: "Hearing",
            group: "primary"
          }, {
            id: "interview",
            text: "Interview",
            group: "primary"
          }, {
            id: "article",
            text: "Journal Article",
            group: "primary"
          }, {
            id: "magazine",
            text: "Magazine",
            group: "primary"
          }, {
            id: "map",
            text: "Map",
            group: "primary"
          }, {
            id: "newspaper_article",
            text: "Newspaper Article",
            group: "primary"
          }, {
            id: "patent",
            text: "Patent",
            group: "primary"
          }, {
            id: "podcast",
            text: "Podcast",
            group: "primary"
          }, {
            id: "presentation",
            text: "Presentation",
            group: "primary"
          }, {
            id: "report",
            text: "Report",
            group: "primary"
          }, {
            id: "statute",
            text: "Statute",
            group: "primary"
          }, {
            id: "thesis",
            text: "Thesis",
            group: "primary"
          }, {
            id: "tv_broadcast",
            text: "TV Broadcast",
            group: "primary"
          }, {
            id: "video_recording",
            text: "Video Recording",
            group: "primary"
          }, {
            id: "webpage",
            text: "Web Page",
            group: "primary"
          }, {
            id: "abstract",
            text: "Abstract",
            group: "primary"
          }, {
            id: "poster",
            text: "Poster",
            group: "primary"
          }]
        }
      },
      readcube: "item_type",
      csl: "type"
    },
    citekey: {
      readcube: "user_data.citekey",
      input: {
        label: "Citekey",
        type: "text",
        required: false,
        array: false,
        pattern: null,
        disabled: false
      }
    },
    radio_broadcast_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    radio_broadcast_director: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Director",
      endnotePath: "contributors.authors.author",
      papers: "directors",
      input: {
        required: false,
        label: "Director",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    radio_broadcast_contributor: {
      ris: "AU",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    radio_broadcast_cast_member: {
      ris: "C1",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Cast Member",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "cast_member"
    },
    radio_broadcast_producer: {
      ris: "A3",
      papers: "producers",
      input: {
        required: false,
        label: "Producer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "producer"
    },
    radio_broadcast_scriptwriter: {
      input: {
        required: false,
        label: "Scriptwriter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "scriptwriter"
    },
    radio_broadcast_guest: {
      papers: "guests",
      input: {
        required: false,
        label: "Guest",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "guest"
    },
    radio_broadcast_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    radio_broadcast_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    radio_broadcast_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    radio_broadcast_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    radio_broadcast_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    radio_broadcast_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    radio_broadcast_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    radio_broadcast_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    radio_broadcast_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    radio_broadcast_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    radio_broadcast_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    radio_broadcast_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    radio_broadcast_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    radio_broadcast_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    radio_broadcast_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    radio_broadcast_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    radio_broadcast_running_time: {
      csl: "dimensions",
      csv: "Running Time",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    radio_broadcast_medium: {
      ris: "C5",
      csl: "medium",
      csv: "Medium",
      endnotePath: "custom5",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    dictionary_entry_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    dictionary_entry_editor: {
      bib: "editor",
      ris: "A2",
      csl: "editor",
      csv: "Editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    dictionary_entry_series_editor: {
      bib: "editorb",
      ris: "A3",
      csl: "collection-editor",
      csv: "Series Editor",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    dictionary_entry_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    dictionary_entry_contributor: {
      bib: "editora",
      csv: "Contributor",
      endnotePath: "contributors.authors.author",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    dictionary_entry_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    dictionary_entry_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    dictionary_entry_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    dictionary_entry_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    dictionary_entry_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    dictionary_entry_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    dictionary_entry_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    dictionary_entry_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    dictionary_entry_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    dictionary_entry_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    dictionary_entry_series: {
      bib: "series",
      csl: "collection-title",
      csv: "Series",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    dictionary_entry_series_number: {
      bib: "number",
      csl: "collection-number",
      csv: "Series Number",
      input: {
        required: false,
        label: "Series Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "collection_number"
    },
    dictionary_entry_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    dictionary_entry_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    dictionary_entry_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    dictionary_entry_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    dictionary_entry_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    dictionary_entry_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    dictionary_entry_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    dictionary_entry_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    dictionary_entry_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    dictionary_entry_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    dictionary_entry_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    encyclopedia_article_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    encyclopedia_article_editor: {
      bib: "editor",
      ris: "A2",
      csl: "editor",
      csv: "Editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    encyclopedia_article_series_editor: {
      bib: "editorb",
      ris: "A3",
      csl: "collection-editor",
      csv: "Series Editor",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    encyclopedia_article_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    encyclopedia_article_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    encyclopedia_article_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    encyclopedia_article_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    encyclopedia_article_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    encyclopedia_article_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    encyclopedia_article_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    encyclopedia_article_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    encyclopedia_article_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    encyclopedia_article_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    encyclopedia_article_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    encyclopedia_article_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    encyclopedia_article_series: {
      bib: "series",
      csl: "collection-title",
      csv: "Series",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    encyclopedia_article_series_number: {
      bib: "number",
      csl: "collection-number",
      csv: "Series Number",
      input: {
        required: false,
        label: "Series Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "collection_number"
    },
    encyclopedia_article_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    encyclopedia_article_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    encyclopedia_article_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    encyclopedia_article_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    encyclopedia_article_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    encyclopedia_article_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    encyclopedia_article_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    encyclopedia_article_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    encyclopedia_article_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    encyclopedia_article_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    encyclopedia_article_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    manuscript_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    manuscript_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    manuscript_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    manuscript_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    manuscript_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    manuscript_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    manuscript_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    manuscript_num_pages: {
      ris: "SP",
      csl: "number-of-pages",
      csv: "Num Pages",
      endnotePath: "pages",
      input: {
        required: false,
        label: "Num Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_pages"
    },
    manuscript_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    manuscript_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    manuscript_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    manuscript_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    manuscript_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    manuscript_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    manuscript_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    manuscript_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    manuscript_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    manuscript_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    manuscript_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    email_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    email_contributor: {
      csl: "author",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    email_recipient: {
      ris: "A2",
      csl: "author",
      endnotePath: "contributors.secondary-authors.author",
      input: {
        required: false,
        label: "Recipient",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "recipient"
    },
    email_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    email_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    email_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    email_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    email_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    email_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    email_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    email_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    email_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    email_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    instant_message_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    instant_message_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    instant_message_recipient: {
      csl: "recipient",
      csv: "Recipient",
      endnotePath: "contributors.secondary-authors.author",
      input: {
        required: false,
        label: "Recipient",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "recipient"
    },
    instant_message_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    instant_message_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    instant_message_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    instant_message_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    instant_message_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    instant_message_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    instant_message_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    instant_message_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    instant_message_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    letter_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    letter_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    letter_recipient: {
      ris: "A2",
      csl: "recipient",
      csv: "Recipient",
      endnotePath: "contributors.secondary-authors.author",
      input: {
        required: false,
        label: "Recipient",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "recipient"
    },
    letter_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    letter_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    letter_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    letter_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    letter_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    letter_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    letter_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    letter_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    letter_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    letter_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    letter_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    letter_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    letter_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    letter_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    letter_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    forum_post_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    forum_post_contributor: {
      bib: "editora",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    forum_post_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    forum_post_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    forum_post_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    forum_post_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    forum_post_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    forum_post_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    forum_post_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    forum_post_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    forum_post_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    forum_post_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    forum_post_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    forum_post_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    blog_post_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    blog_post_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    blog_post_commenter: {
      bib: "commentator",
      ris: "C2",
      csv: "Commenter",
      papers: "reviwers",
      input: {
        required: false,
        label: "Commenter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "commenter"
    },
    blog_post_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    blog_post_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    blog_post_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    blog_post_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    blog_post_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    blog_post_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    blog_post_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    blog_post_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    blog_post_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    blog_post_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    blog_post_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    blog_post_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    artwork_artist: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Artist",
      endnotePath: "contributors.authors.author",
      papers: "designers",
      input: {
        required: false,
        label: "Artist",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    artwork_contributor: {
      bib: "editora",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    artwork_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    artwork_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    artwork_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    artwork_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    artwork_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    artwork_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    artwork_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    artwork_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    artwork_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    artwork_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    artwork_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    artwork_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    artwork_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    artwork_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    artwork_medium: {
      ris: "M3",
      csl: "medium",
      csv: "Medium",
      endnotePath: "misc2",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    artwork_artwork_size: {
      ris: "C3",
      csl: "dimensions",
      csv: "Artwork Size",
      endnotePath: "custom3",
      input: {
        required: false,
        label: "Artwork Size",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    audio_recording_performer: {
      bib: "author",
      ris: "A2",
      csl: "author",
      csv: "Performer",
      endnotePath: "contributors.secondary-authors.author",
      papers: "performers",
      input: {
        required: false,
        label: "Performer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    audio_recording_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    audio_recording_composer: {
      ris: "AU",
      csv: "Composer",
      papers: "composed",
      input: {
        required: false,
        label: "Composer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "composer"
    },
    audio_recording_words_by: {
      ris: "C4",
      csv: "Words By",
      input: {
        required: false,
        label: "Words By",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "words_by"
    },
    audio_recording_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    audio_recording_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    audio_recording_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    audio_recording_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    audio_recording_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    audio_recording_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    audio_recording_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    audio_recording_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    audio_recording_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    audio_recording_series_title: {
      ris: "T3",
      csl: "collection-title",
      csv: "Series Title",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    audio_recording_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    audio_recording_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    audio_recording_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    audio_recording_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    audio_recording_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    audio_recording_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    audio_recording_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    audio_recording_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    audio_recording_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    audio_recording_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    audio_recording_running_time: {
      csl: "dimensions",
      csv: "Running Time",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    audio_recording_medium: {
      ris: "C5",
      csl: "medium",
      csv: "Medium",
      endnotePath: "custom5",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    bill_sponsor: {
      bib: "author",
      ris: "A2",
      csl: "author",
      csv: "Sponsor",
      endnotePath: "contributors.secondary-authors.author",
      papers: "co-sponsors",
      input: {
        required: false,
        label: "Sponsor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    bill_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    bill_cosponsor: {
      ris: "A3",
      csv: "Cosponsor",
      endnotePath: "contributors.tertiary-authors.author",
      papers: "co-sponsors",
      input: {
        required: false,
        label: "Cosponsor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "cosponsor"
    },
    bill_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    bill_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    bill_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    bill_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    bill_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    bill_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    bill_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    bill_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    bill_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    bill_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    bill_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    bill_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    bill_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    bill_code: {
      ris: "T2",
      csl: "container-title",
      csv: "Code",
      endnotePath: "titles.secondary-title",
      papers: "code",
      input: {
        required: false,
        label: "Code",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    bill_section: {
      bib: "chapter",
      ris: "SE",
      csl: "section",
      csv: "Section",
      endnotePath: "section",
      papers: "section",
      input: {
        required: false,
        label: "Section",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "section"
    },
    bill_session: {
      ris: "ET",
      csl: "chapter-number",
      csv: "Session",
      endnotePath: "edition",
      papers: "session",
      input: {
        required: false,
        label: "Session",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "chapter_number"
    },
    bill_history: {
      ris: "OP",
      csl: "references",
      csv: "History",
      endnotePath: "orig-pub",
      input: {
        required: false,
        label: "History",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "references"
    },
    bill_legislative_body: {
      ris: "T3",
      csl: "authority",
      csv: "Legislative Body",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Legislative Body",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "authority"
    },
    book_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    book_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    book_editor: {
      bib: "editor",
      ris: "A3",
      csl: "editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    book_series_editor: {
      bib: "editorb",
      ris: "A2",
      csl: "collection-editor",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    book_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    book_contributor: {
      bib: "editora",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    book_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    book_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    book_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    book_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    book_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    book_num_pages: {
      ris: "SP",
      csl: "number-of-pages",
      csv: "Num Pages",
      endnotePath: "pages",
      input: {
        required: false,
        label: "Num Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_pages"
    },
    book_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    book_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    book_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    book_series: {
      bib: "series",
      ris: "T2",
      csl: "collection-title",
      csv: "Series",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    book_series_number: {
      bib: "number",
      ris: "M1",
      csl: "collection-number",
      csv: "Series Number",
      endnotePath: "misc1",
      input: {
        required: false,
        label: "Series Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "collection_number"
    },
    book_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    book_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    book_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    book_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    book_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    book_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    book_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    book_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    book_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    book_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    book_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    book_doi: {
      bib: "doi",
      ris: "DO",
      csl: "DOI",
      csv: "DOI",
      endnotePath: "electronic-resource-num",
      papers: "doi",
      input: {
        required: false,
        label: "DOI",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^10.\\d{4,9}\\/[-._;()/:A-Z0-9<>+\\[\\]]+(?:(?<=-)#)?",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.doi"
    },
    book_section_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    book_section_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    book_section_editor: {
      bib: "editor",
      ris: "A2",
      csl: "editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    book_section_series_editor: {
      bib: "editorb",
      ris: "A3",
      csl: "collection-editor",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    book_section_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    book_section_contributor: {
      bib: "editora",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    book_section_book_author: {
      bib: "bookauthor",
      ris: "C2",
      csl: "container-author",
      papers: "authors",
      input: {
        required: false,
        label: "Book Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "book_author"
    },
    book_section_publication_title: {
      bib: "booktitle",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    book_section_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    book_section_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    book_section_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    book_section_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    book_section_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    book_section_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    book_section_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    book_section_number_of_volumes: {
      ris: "IS",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "issue",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    book_section_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    book_section_series: {
      bib: "series",
      ris: "T3",
      csl: "collection-title",
      csv: "Series",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    book_section_series_number: {
      bib: "number",
      ris: "SV",
      csl: "collection-number",
      csv: "Series Number",
      endnotePath: "number",
      input: {
        required: false,
        label: "Series Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "collection_number"
    },
    book_section_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    book_section_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    book_section_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    book_section_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    book_section_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    book_section_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    book_section_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    book_section_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    book_section_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    book_section_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    book_section_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    book_section_doi: {
      bib: "doi",
      ris: "DO",
      csl: "DOI",
      csv: "DOI",
      endnotePath: "electronic-resource-num",
      papers: "doi",
      input: {
        required: false,
        label: "DOI",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^10.\\d{4,9}\\/[-._;()/:A-Z0-9<>+\\[\\]]+(?:(?<=-)#)?",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.doi"
    },
    case_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    case_contributor: {
      csl: "author",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    case_counsel: {
      ris: "A4",
      csl: "author",
      csv: "Counsel",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "judges",
      input: {
        required: false,
        label: "Counsel",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "counsel"
    },
    case_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    case_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    case_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    case_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    case_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    case_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    case_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    case_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    case_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    case_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    case_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    case_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    case_number: {
      ris: "SV",
      csl: "number",
      csv: "Number",
      endnotePath: "number",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    case_court: {
      ris: "PB",
      csl: "authority",
      csv: "Court",
      endnotePath: "publisher",
      papers: "court",
      input: {
        required: false,
        label: "Court",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "authority"
    },
    case_reporter: {
      ris: "A2",
      csl: "container-title",
      csv: "Reporter",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Reporter",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    case_history: {
      ris: "OP",
      csl: "references",
      csv: "History",
      endnotePath: "orig-pub",
      input: {
        required: false,
        label: "History",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "references"
    },
    computer_program_programmer: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Programmer",
      endnotePath: "contributors.authors.author",
      input: {
        required: false,
        label: "Programmer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    computer_program_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    computer_program_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    computer_program_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    computer_program_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    computer_program_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    computer_program_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    computer_program_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    computer_program_series_title: {
      ris: "T2",
      csl: "collection-title",
      csv: "Series Title",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    computer_program_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    computer_program_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    computer_program_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    computer_program_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    computer_program_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    computer_program_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    computer_program_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    computer_program_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    computer_program_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    computer_program_programming_language: {
      ris: "LA",
      csl: "genre",
      csv: "Programming Language",
      papers: "language",
      input: {
        required: false,
        label: "Programming Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    computer_program_version: {
      ris: "ET",
      csl: "version",
      csv: "Version",
      endnotePath: "edition",
      papers: "version",
      input: {
        required: false,
        label: "Version",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "version"
    },
    computer_program_system: {
      ris: "M1",
      csl: "medium",
      csv: "System",
      endnotePath: "misc1",
      input: {
        required: false,
        label: "System",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    conference_paper_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    conference_paper_editor: {
      csv: "translator",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    conference_paper_contributor: {
      csv: "editora",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    conference_paper_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    conference_paper_proceedings_title: {
      bib: "booktitle",
      ris: "C3",
      csl: "container-title",
      csv: "Proceedings Title",
      endnotePath: "custom3",
      input: {
        required: false,
        label: "Proceedings Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    conference_paper_type: {
      ris: "M3",
      csl: "work-type",
      csv: "Work Type",
      endnotePath: "work-type",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "work_type"
    },
    conference_paper_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    conference_paper_doi: {
      bib: "doi",
      ris: "DO",
      csl: "DOI",
      csv: "DOI",
      endnotePath: "electronic-resource-num",
      papers: "doi",
      input: {
        required: false,
        label: "DOI",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^10.\\d{4,9}\\/[-._;()/:A-Z0-9<>+\\[\\]]+(?:(?<=-)#)?",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.doi"
    },
    conference_paper_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    conference_paper_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    conference_paper_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    conference_paper_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    conference_paper_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    conference_paper_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    conference_paper_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    conference_paper_series: {
      bib: "series",
      ris: "T3",
      csl: "collection-title",
      csv: "Series",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    conference_paper_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    conference_paper_place: {
      bib: "address",
      ris: "C1",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    conference_paper_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    conference_paper_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    conference_paper_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    conference_paper_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    conference_paper_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    conference_paper_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    conference_paper_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    conference_paper_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    conference_paper_conference_name: {
      ris: "T2",
      csl: "event",
      csv: "Conference Name",
      endnotePath: "titles.secondary-title",
      papers: "event",
      input: {
        required: false,
        label: "Conference Name",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event"
    },
    document_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    document_editor: {
      bib: "editor",
      ris: "A2",
      csv: "Editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    document_translator: {
      bib: "translator",
      ris: "A4",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    document_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    document_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    document_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    document_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    document_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    document_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    document_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    document_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    document_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    document_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    document_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    document_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    document_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    document_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    document_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    document_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    film_director: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Director",
      endnotePath: "contributors.authors.author",
      papers: "directors",
      input: {
        required: false,
        label: "Director",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    film_contributor: {
      ris: "A4",
      csv: "Contributor",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    film_producer: {
      ris: "A3",
      csv: "Producer",
      papers: "producers",
      input: {
        required: false,
        label: "Producer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "producer"
    },
    film_scriptwriter: {
      csv: "Scriptwriter",
      input: {
        required: false,
        label: "Scriptwriter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "scriptwriter"
    },
    film_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    film_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    film_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    film_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    film_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    film_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    film_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    film_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    film_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    film_type: {
      bib: "type",
      ris: "C4",
      csl: "genre",
      csv: "Type",
      endnotePath: "custom4",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    film_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    film_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    film_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    film_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    film_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    film_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    film_running_time: {
      ris: "SP",
      csl: "dimensions",
      csv: "Running Time",
      endnotePath: "pages",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    film_medium: {
      ris: "C5",
      csl: "medium",
      csv: "Medium",
      endnotePath: "custom5",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    hearing_contributor: {
      bib: "author",
      csl: "author",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    hearing_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    hearing_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    hearing_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    hearing_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    hearing_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    hearing_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    hearing_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    hearing_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    hearing_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    hearing_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    hearing_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    hearing_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    hearing_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    hearing_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    hearing_session: {
      ris: "ET",
      csl: "chapter-number",
      csv: "Session",
      endnotePath: "edition",
      papers: "session",
      input: {
        required: false,
        label: "Session",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "chapter_number"
    },
    hearing_committee: {
      ris: "T2",
      csl: "section",
      csv: "Committee",
      endnotePath: "titles.secondary-title",
      papers: "committe",
      input: {
        required: false,
        label: "Committee",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "section"
    },
    hearing_history: {
      ris: "OP",
      csl: "references",
      csv: "History",
      endnotePath: "orig-pub",
      input: {
        required: false,
        label: "History",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "references"
    },
    hearing_legislative_body: {
      ris: "T3",
      csl: "authority",
      csv: "Legislative Body",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Legislative Body",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "authority"
    },
    interview_interview_with: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Interview With",
      endnotePath: "contributors.authors.author",
      papers: "interviewers",
      input: {
        required: false,
        label: "Interview With",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    interview_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    interview_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    interview_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    interview_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    interview_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    interview_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    interview_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    interview_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    interview_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    interview_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    interview_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    interview_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    interview_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    interview_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    interview_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    interview_medium: {
      ris: "M3",
      csl: "medium",
      csv: "Medium",
      endnotePath: "misc2",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    article_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    article_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    article_journal: {
      bib: "journal, journaltitle",
      ris: "T2",
      csl: "container-title",
      csv: "Journal",
      endnotePath: "periodical.full-title,titles.secondary-title",
      papers: "journal",
      input: {
        required: false,
        label: "Journal",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    article_issn: {
      bib: "issn",
      ris: "SN",
      csl: "ISSN",
      csv: "ISSN",
      endnotePath: "isbn",
      input: {
        required: false,
        label: "ISSN",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^[0-9]{4}-[0-9]{3}[0-9x]",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "article.issn"
    },
    article_doi: {
      bib: "doi",
      ris: "DO",
      csl: "DOI",
      csv: "DOI",
      endnotePath: "electronic-resource-num",
      papers: "doi",
      input: {
        required: false,
        label: "DOI",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^10.\\d{4,9}\\/[-._;()/:A-Z0-9<>+\\[\\]]+(?:(?<=-)#)?",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.doi"
    },
    article_pmid: {
      bib: "pmid",
      ris: "PMID,U1",
      csl: "PMID",
      csv: "PMID",
      papers: "pmid",
      input: {
        required: false,
        label: "PMID",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^(pmid:)?\\d{2,8}$",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.pmid"
    },
    article_pmcid: {
      bib: "pmcid",
      ris: "U2",
      csl: "PMCID",
      csv: "PMCID",
      papers: "pmcid",
      input: {
        required: false,
        label: "PMCID",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^PMC\\d+$",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.pmcid"
    },
    article_arxiv: {
      bib: "eprint",
      csl: "arXiv",
      csv: "ArXiv",
      input: {
        required: false,
        label: "ArXiv",
        type: "text",
        array: false,
        disabled: false,
        pattern: "(^(arxiv:)?\\d{4}\\.\\d{4,6}v?\\d*$)|(^[-a-z]+\\/\\d{7}v?\\d*$)",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.arxiv"
    },
    article_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    article_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    article_date: {
      bib: "year, date",
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    article_journal_abbreviation: {
      ris: "J2",
      csl: "journalAbbreviation",
      csv: "Journal Abbreviation",
      endnotePath: "periodical.abbr-1",
      input: {
        required: false,
        label: "Journal Abbreviation",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal_abbrev"
    },
    article_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    article_editor: {
      bib: "editor",
      ris: "A2",
      csl: "editor",
      csv: "Editor",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    article_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    article_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    article_reviewed_author: {
      csl: "reviewed-author",
      csv: "Reviewed Author",
      papers: "reviewers",
      input: {
        required: false,
        label: "Reviewed Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "reviewed_author"
    },
    article_publication_title: {
      bib: "journaltitle",
      csl: "collection-title",
      csv: "Publication Title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    article_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    article_issue: {
      bib: "number",
      ris: "IS",
      csl: "issue",
      csv: "Issue",
      endnotePath: "issue",
      papers: "issue",
      input: {
        required: false,
        label: "Issue",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.issue"
    },
    article_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    article_series: {
      bib: "series",
      ris: "T3",
      csv: "Series",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "series"
    },
    article_series_text: {
      csv: "Series Text",
      input: {
        required: false,
        label: "Series Text",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_text"
    },
    article_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    article_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    article_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    article_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    article_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    article_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    article_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    article_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    magazine_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    magazine_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    magazine_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    magazine_reviewed_author: {
      csl: "reviewed-author",
      csv: "Reviewed Author",
      papers: "reviewers",
      input: {
        required: false,
        label: "Reviewed Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "reviewed_author"
    },
    magazine_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    magazine_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    magazine_issn: {
      bib: "issn",
      ris: "SN",
      csl: "ISSN",
      csv: "ISSN",
      endnotePath: "isbn",
      input: {
        required: false,
        label: "ISSN",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^[0-9]{4}-[0-9]{3}[0-9x]",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "article.issn"
    },
    magazine_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    magazine_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    magazine_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    magazine_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    magazine_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    magazine_issue: {
      bib: "number",
      ris: "IS",
      csl: "issue",
      csv: "Issue",
      endnotePath: "issue",
      papers: "issue",
      input: {
        required: false,
        label: "Issue",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.issue"
    },
    magazine_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    magazine_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    magazine_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    magazine_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    magazine_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    magazine_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    magazine_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    magazine_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    magazine_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    magazine_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    map_cartographer: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Cartographer",
      endnotePath: "contributors.authors.author",
      input: {
        required: false,
        label: "Cartographer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    map_series_editor: {
      bib: "editorb",
      ris: "A3",
      csl: "collection-editor",
      csv: "Series Editor",
      endnotePath: "contributors.tertiary-authors.author",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    map_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    map_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    map_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    map_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    map_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    map_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    map_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    map_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    map_series_title: {
      ris: "T2",
      csl: "collection-title",
      csv: "Series Title",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    map_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    map_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    map_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    map_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    map_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    map_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    map_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    map_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    map_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    map_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    map_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    map_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    map_scale: {
      ris: "C1",
      csl: "scale",
      csv: "Scale",
      endnotePath: "custom1",
      papers: "scale",
      input: {
        required: false,
        label: "Scale",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "scale"
    },
    newspaper_article_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    newspaper_article_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    newspaper_article_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    newspaper_article_reviewed_author: {
      csl: "reviewed-author",
      csv: "Reviewed Author",
      papers: "reviewers",
      input: {
        required: false,
        label: "Reviewed Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "reviewed_author"
    },
    newspaper_article_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    newspaper_article_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    newspaper_article_issn: {
      bib: "issn",
      ris: "SN",
      csl: "ISSN",
      csv: "ISSN",
      endnotePath: "isbn",
      input: {
        required: false,
        label: "ISSN",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^[0-9]{4}-[0-9]{3}[0-9x]",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "article.issn"
    },
    newspaper_article_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    newspaper_article_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    newspaper_article_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    newspaper_article_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    newspaper_article_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    newspaper_article_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    newspaper_article_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    newspaper_article_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    newspaper_article_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    newspaper_article_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    newspaper_article_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    newspaper_article_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    newspaper_article_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    newspaper_article_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    newspaper_article_edition: {
      bib: "edition",
      ris: "ET",
      csl: "edition",
      csv: "Edition",
      endnotePath: "edition",
      papers: "edition",
      input: {
        required: false,
        label: "Edition",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "edition"
    },
    newspaper_article_section: {
      bib: "chapter",
      ris: "SE",
      csl: "section",
      csv: "Section",
      endnotePath: "section",
      papers: "section",
      input: {
        required: false,
        label: "Section",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "section"
    },
    patent_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    patent_inventor: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Inventor",
      endnotePath: "contributors.authors.author",
      input: {
        required: false,
        label: "Inventor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    patent_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    patent_patent_id: {
      ris: "M1",
      csl: "call-number",
      csv: "Patent ID",
      endnotePath: "misc1",
      input: {
        required: false,
        label: "Patent ID",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "ext_ids.patent_id"
    },
    patent_application_number: {
      csv: "Application Number",
      input: {
        required: false,
        label: "Application Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "application_number"
    },
    patent_guest: {
      csv: "Guest",
      papers: "guests",
      input: {
        required: false,
        label: "Guest",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "guest"
    },
    patent_attorney_agent: {
      ris: "C4",
      csv: "Attorney Agent",
      endnotePath: "custom4",
      papers: "attorneys",
      input: {
        required: false,
        label: "Attorney Agent",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "attorney_agent"
    },
    patent_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    patent_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    patent_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "custom2",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    patent_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    patent_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    patent_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    patent_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    patent_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    patent_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    patent_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    patent_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    patent_number: {
      bib: "number",
      ris: "SN",
      csl: "number",
      csv: "Number",
      endnotePath: "isbn",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    patent_filing_date: {
      ris: "C1",
      csv: "Filing Date",
      endnotePath: "custom1",
      input: {
        required: false,
        label: "Filing Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "filing_date"
    },
    patent_publication_date: {
      csv: "Publication Date",
      input: {
        required: false,
        label: "Publication Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publication_date"
    },
    patent_assignee: {
      bib: "assignee",
      ris: "PB",
      csv: "Assignee",
      endnotePath: "publisher",
      input: {
        required: false,
        label: "Assignee",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "assignee"
    },
    patent_issuing_authority: {
      ris: "A2",
      csl: "authority",
      csv: "Issuing Authority",
      input: {
        required: false,
        label: "Issuing Authority",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "authority"
    },
    patent_country: {
      bib: "nationality",
      ris: "C3",
      csv: "Country",
      endnotePath: "custom3",
      papers: "country",
      input: {
        required: false,
        label: "Country",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "country"
    },
    patent_references: {
      ris: "C5",
      csl: "references",
      csv: "References",
      endnotePath: "custom5",
      papers: "reference",
      input: {
        required: false,
        label: "References",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "references"
    },
    patent_legal_status: {
      ris: "C6",
      csl: "status",
      csv: "Legal Status",
      endnotePath: "custom6",
      input: {
        required: false,
        label: "Legal Status",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "status"
    },
    patent_priority_numbers: {
      ris: "OP",
      csl: "issue",
      csv: "Priority Numbers",
      endnotePath: "orig-pub",
      input: {
        required: false,
        label: "Priority Numbers",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.issue"
    },
    podcast_podcaster: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Podcaster",
      endnotePath: "contributors.authors.author",
      input: {
        required: false,
        label: "Podcaster",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    podcast_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    podcast_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    podcast_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    podcast_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    podcast_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    podcast_series_title: {
      csl: "collection-title",
      csv: "Series Title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    podcast_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    podcast_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    podcast_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    podcast_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    podcast_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    podcast_running_time: {
      csl: "dimensions",
      csv: "Running Time",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    podcast_medium: {
      ris: "M3",
      csl: "medium",
      csv: "Medium",
      endnotePath: "misc2",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    presentation_presenter: {
      bib: "author",
      ris: "A2",
      csl: "author",
      csv: "Presenter",
      endnotePath: "contributors.secondary-authors.author",
      input: {
        required: false,
        label: "Presenter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    presentation_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    presentation_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    presentation_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    presentation_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    presentation_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    presentation_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    presentation_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    presentation_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    presentation_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    presentation_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    presentation_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    presentation_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    presentation_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    presentation_meeting_name: {
      ris: "T2",
      csl: "event",
      csv: "Meeting Name",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Meeting Name",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event"
    },
    report_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    report_series_editor: {
      bib: "editorb",
      ris: "A2",
      csl: "collection-editor",
      csv: "Series Editor",
      input: {
        required: false,
        label: "Series Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "series_editor"
    },
    report_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    report_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    report_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    report_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    report_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    report_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    report_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    report_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    report_series_title: {
      ris: "T2",
      csl: "collection-title",
      csv: "Series Title",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    report_publisher: {
      bib: "institution",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    report_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    report_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    report_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    report_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    report_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    report_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    report_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    report_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    report_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    report_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    report_number: {
      bib: "number",
      ris: "SN",
      csl: "number",
      csv: "Number",
      endnotePath: "isbn",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    statute_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    statute_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    statute_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    statute_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    statute_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    statute_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    statute_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    statute_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    statute_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    statute_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    statute_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    statute_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    statute_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    statute_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    statute_code: {
      ris: "T2",
      csl: "container-title",
      csv: "Code",
      endnotePath: "titles.secondary-title",
      papers: "code",
      input: {
        required: false,
        label: "Code",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    statute_code_number: {
      ris: "VL",
      csl: "volume",
      csv: "Code Number",
      endnotePath: "volume",
      input: {
        required: false,
        label: "Code Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    statute_section: {
      bib: "chapter",
      ris: "SE",
      csl: "section",
      csv: "Section",
      endnotePath: "section",
      papers: "section",
      input: {
        required: false,
        label: "Section",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "section"
    },
    statute_session: {
      ris: "ET",
      csl: "chapter-number",
      csv: "Session",
      endnotePath: "edition",
      papers: "session",
      input: {
        required: false,
        label: "Session",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "chapter_number"
    },
    statute_history: {
      ris: "OP",
      csl: "references",
      csv: "History",
      endnotePath: "orig-pub",
      input: {
        required: false,
        label: "History",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "references"
    },
    thesis_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    thesis_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    thesis_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    thesis_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    thesis_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    thesis_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    thesis_publisher: {
      bib: "institution",
      ris: "PB",
      csl: "publisher",
      csv: "publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    thesis_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    tv_broadcast_director: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Director",
      endnotePath: "contributors.authors.author",
      papers: "directors",
      input: {
        required: false,
        label: "Director",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    tv_broadcast_cast_member: {
      ris: "C1",
      csv: "Cast Member",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Cast Member",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "cast_member"
    },
    tv_broadcast_producer: {
      ris: "A3",
      csv: "Producer",
      papers: "producers",
      input: {
        required: false,
        label: "Producer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "producer"
    },
    tv_broadcast_scriptwriter: {
      csv: "Scriptwriter",
      input: {
        required: false,
        label: "Scriptwriter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "scriptwriter"
    },
    tv_broadcast_guest: {
      csv: "Guest",
      papers: "guests",
      input: {
        required: false,
        label: "Guest",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "guest"
    },
    tv_broadcast_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    tv_broadcast_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    tv_broadcast_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    tv_broadcast_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    tv_broadcast_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    tv_broadcast_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    tv_broadcast_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    tv_broadcast_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    tv_broadcast_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    tv_broadcast_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    tv_broadcast_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    tv_broadcast_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    tv_broadcast_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    tv_broadcast_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    tv_broadcast_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    tv_broadcast_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    tv_broadcast_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    tv_broadcast_number: {
      ris: "M1",
      csl: "number",
      csv: "Number",
      endnotePath: "misc1",
      papers: "number",
      input: {
        required: false,
        label: "Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number"
    },
    tv_broadcast_running_time: {
      csl: "dimensions",
      csv: "Running Time",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    tv_broadcast_medium: {
      ris: "C5",
      csl: "medium",
      csv: "Medium",
      endnotePath: "custom5",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    video_recording_director: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Director",
      endnotePath: "contributors.authors.author",
      papers: "directors",
      input: {
        required: false,
        label: "Director",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    video_recording_contributor: {
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    video_recording_cast_member: {
      ris: "C1",
      csv: "Cast Member",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Cast Member",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "cast_member"
    },
    video_recording_producer: {
      ris: "A3",
      csv: "Producer",
      papers: "producers",
      input: {
        required: false,
        label: "Producer",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "producer"
    },
    video_recording_scriptwriter: {
      csv: "Scriptwriter",
      input: {
        required: false,
        label: "Scriptwriter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "scriptwriter"
    },
    video_recording_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    video_recording_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    video_recording_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    video_recording_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    video_recording_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    video_recording_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    video_recording_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    video_recording_number_of_volumes: {
      ris: "NV",
      csl: "number-of-volumes",
      csv: "Number Of Volumes",
      endnotePath: "num-vols",
      papers: "volume",
      input: {
        required: false,
        label: "Number Of Volumes",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "number_of_volumes"
    },
    video_recording_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    video_recording_series_title: {
      csl: "collection-title",
      csv: "Series Title",
      input: {
        required: false,
        label: "Series Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    video_recording_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    video_recording_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    video_recording_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    video_recording_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    video_recording_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    video_recording_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    video_recording_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    video_recording_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    video_recording_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    video_recording_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    video_recording_running_time: {
      csl: "dimensions",
      csv: "Running Time",
      endnotePath: "custom3",
      papers: "time",
      input: {
        required: false,
        label: "Running Time",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "dimensions"
    },
    video_recording_medium: {
      ris: "C5",
      csl: "medium",
      csv: "Medium",
      endnotePath: "custom5",
      papers: "material",
      input: {
        required: false,
        label: "Medium",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "medium"
    },
    webpage_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    webpage_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    webpage_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    webpage_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    webpage_translator: {
      bib: "translator",
      ris: "A4",
      csl: "translator",
      csv: "Translator",
      endnotePath: "contributors.subsidiary-authors.author",
      papers: "translators",
      input: {
        required: false,
        label: "Translator",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "translator"
    },
    webpage_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    webpage_publication_title: {
      bib: "journal",
      ris: "T2",
      csl: "container-title",
      csv: "Publication Title",
      endnotePath: "periodical.full-title",
      papers: "book",
      input: {
        required: false,
        label: "Publication Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    webpage_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    webpage_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    webpage_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    webpage_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    webpage_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    webpage_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    webpage_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    webpage_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    abstract_author: {
      bib: "author",
      ris: "AU",
      csl: "author",
      csv: "Author",
      endnotePath: "contributors.authors.author",
      papers: "authors",
      input: {
        required: false,
        label: "Author",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    abstract_editor: {
      csv: "translator",
      papers: "editors",
      input: {
        required: false,
        label: "Editor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "editor"
    },
    abstract_contributor: {
      csv: "editora",
      endnotePath: "contributors.subsidiary-authors.author",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    abstract_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    abstract_proceedings_title: {
      bib: "booktitle",
      ris: "C3",
      csl: "container-title",
      csv: "Proceedings Title",
      endnotePath: "custom3",
      input: {
        required: false,
        label: "Proceedings Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "container_title"
    },
    abstract_type: {
      ris: "M3",
      csl: "work-type",
      csv: "Work Type",
      endnotePath: "work-type",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "work_type"
    },
    abstract_isbn: {
      bib: "isbn",
      ris: "SN",
      csl: "ISBN",
      csv: "ISBN",
      endnotePath: "isbn",
      papers: "isbn",
      input: {
        required: false,
        label: "ISBN",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.isbn"
    },
    abstract_doi: {
      bib: "doi",
      ris: "DO",
      csl: "DOI",
      csv: "DOI",
      endnotePath: "electronic-resource-num",
      papers: "doi",
      input: {
        required: false,
        label: "DOI",
        type: "text",
        array: false,
        disabled: false,
        pattern: "^10.\\d{4,9}\\/[-._;()/:A-Z0-9<>+\\[\\]]+(?:(?<=-)#)?",
        pattern_insensitive: true,
        warning: false
      },
      readcube: "ext_ids.doi"
    },
    abstract_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    abstract_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    abstract_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    abstract_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    abstract_pages: {
      bib: "pages",
      ris: "SP",
      csl: "page",
      csv: "Pages",
      endnotePath: "pages",
      papers: "pages",
      input: {
        required: false,
        label: "Pages",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.pagination"
    },
    abstract_volume: {
      bib: "volume",
      ris: "VL",
      csl: "volume",
      csv: "Volume",
      endnotePath: "volume",
      papers: "volume",
      input: {
        required: false,
        label: "Volume",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.volume"
    },
    abstract_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    abstract_series: {
      bib: "series",
      ris: "T3",
      csl: "collection-title",
      csv: "Series",
      endnotePath: "titles.tertiary-title",
      input: {
        required: false,
        label: "Series",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.journal"
    },
    abstract_publisher: {
      bib: "publisher",
      ris: "PB",
      csl: "publisher",
      csv: "Publisher",
      endnotePath: "publisher",
      papers: "publisher",
      input: {
        required: false,
        label: "Publisher",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "publisher"
    },
    abstract_place: {
      bib: "address",
      ris: "C1",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    abstract_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    abstract_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    abstract_archive: {
      ris: "DB",
      csl: "archive",
      csv: "Archive",
      papers: "archived",
      input: {
        required: false,
        label: "Archive",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive"
    },
    abstract_archive_location: {
      ris: "AN",
      csl: "archive_location",
      csv: "Archive Location",
      papers: "location",
      input: {
        required: false,
        label: "Archive Location",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "archive_location"
    },
    abstract_library_catalog: {
      ris: "DP",
      csl: "source",
      csv: "Library Catalog",
      endnotePath: "remote-database-name",
      input: {
        required: false,
        label: "Library Catalog",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "source"
    },
    abstract_call_number: {
      ris: "CN",
      csl: "call-number",
      csv: "Call Number",
      endnotePath: "call-num",
      papers: "call",
      input: {
        required: false,
        label: "Call Number",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "call_number"
    },
    abstract_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    abstract_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    abstract_conference_name: {
      ris: "T2",
      csl: "event",
      csv: "Conference Name",
      endnotePath: "titles.secondary-title",
      papers: "event",
      input: {
        required: false,
        label: "Conference Name",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event"
    },
    poster_presenter: {
      bib: "author",
      ris: "A2",
      csl: "author",
      csv: "Presenter",
      endnotePath: "contributors.secondary-authors.author",
      input: {
        required: false,
        label: "Presenter",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "article.authors"
    },
    poster_contributor: {
      bib: "editora",
      csv: "Contributor",
      input: {
        required: false,
        label: "Contributor",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      custom_metadata: "contributor"
    },
    poster_title: {
      bib: "title",
      ris: "TI",
      csl: "title",
      csv: "Title",
      endnotePath: "titles.title",
      papers: "title",
      input: {
        required: false,
        label: "Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.title"
    },
    poster_url: {
      bib: "url",
      ris: "UR",
      csl: "URL",
      csv: "Url",
      endnotePath: "urls.web-urls.url,urls.related-urls.url",
      papers: "url",
      input: {
        required: false,
        label: "Url",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "url"
    },
    poster_abstract: {
      bib: "abstract",
      ris: "AB",
      csl: "abstract",
      csv: "Abstract",
      endnotePath: "abstract",
      papers: "abstract",
      input: {
        required: false,
        label: "Abstract",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "article.abstract"
    },
    poster_date: {
      ris: "PY",
      csl: "issued",
      csv: "Date",
      endnotePath: "dates.year, dates.pub-dates.date",
      input: {
        required: false,
        label: "Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "date"
    },
    poster_access_date: {
      bib: "urldate",
      csl: "accessed",
      csv: "Access Date",
      endnotePath: "access-date",
      papers: "accessed",
      input: {
        required: false,
        label: "Access Date",
        type: "date",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "accessed"
    },
    poster_short_title: {
      bib: "shorttitle",
      ris: "ST",
      csl: "title-short",
      csv: "Short Title",
      endnotePath: "titles.short-title",
      input: {
        required: false,
        label: "Short Title",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "title_short"
    },
    poster_place: {
      bib: "address",
      ris: "CY",
      csl: "publisher-place",
      csv: "Place",
      endnotePath: "pub-location",
      papers: "location",
      input: {
        required: false,
        label: "Place",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event_place"
    },
    poster_language: {
      bib: "language",
      ris: "LA",
      csl: "language",
      csv: "Language",
      endnotePath: "language",
      papers: "language",
      input: {
        required: false,
        label: "Language",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "language"
    },
    poster_rights: {
      bib: "copyright",
      csv: "Rights",
      input: {
        required: false,
        label: "Rights",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "rights"
    },
    poster_type: {
      bib: "type",
      ris: "M3",
      csl: "genre",
      csv: "Type",
      endnotePath: "misc2",
      input: {
        required: false,
        label: "Type",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "genre"
    },
    poster_notes: {
      bib: "note",
      ris: "N1",
      csl: "note",
      csv: "Notes",
      endnotePath: "notes",
      input: {
        required: false,
        label: "Notes",
        type: "textarea",
        array: false,
        disabled: false,
        warning: false
      },
      readcube: "user_data.notes"
    },
    poster_tags: {
      bib: "keywords",
      ris: "KW",
      csv: "Tags",
      endnotePath: "keywords.keyword",
      input: {
        required: false,
        label: "Tags",
        type: "text",
        array: true,
        disabled: false,
        warning: false
      },
      readcube: "user_data.tags"
    },
    poster_meeting_name: {
      ris: "T2",
      csl: "event",
      csv: "Meeting Name",
      endnotePath: "titles.secondary-title",
      input: {
        required: false,
        label: "Meeting Name",
        type: "text",
        array: false,
        disabled: false,
        warning: false
      },
      custom_metadata: "event"
    }
  },
  types: {
    radio_broadcast: {
      category: "primary",
      csl_type: "broadcast",
      bib_type: "misc",
      ris_type: "SOUND",
      csv_type: "Radio Broadcast",
      item_type: "radio_broadcast",
      fields: ["type", "radio_broadcast_title", "radio_broadcast_director", "radio_broadcast_contributor", "radio_broadcast_cast_member", "radio_broadcast_producer", "radio_broadcast_scriptwriter", "radio_broadcast_guest", "radio_broadcast_publication_title", "radio_broadcast_url", "radio_broadcast_abstract", "radio_broadcast_date", "radio_broadcast_short_title", "radio_broadcast_publisher", "radio_broadcast_place", "radio_broadcast_language", "radio_broadcast_rights", "radio_broadcast_archive", "radio_broadcast_archive_location", "radio_broadcast_library_catalog", "radio_broadcast_call_number", "radio_broadcast_notes", "radio_broadcast_tags", "radio_broadcast_number", "radio_broadcast_running_time", "radio_broadcast_medium", "citekey"]
    },
    dictionary_entry: {
      category: "primary",
      csl_type: "entry-dictionary",
      bib_type: "misc",
      ris_type: "DICT",
      csv_type: "Dictionary Entry",
      item_type: "dictionary_entry",
      fields: ["type", "dictionary_entry_author", "dictionary_entry_editor", "dictionary_entry_series_editor", "dictionary_entry_translator", "dictionary_entry_contributor", "dictionary_entry_title", "dictionary_entry_publication_title", "dictionary_entry_isbn", "dictionary_entry_url", "dictionary_entry_abstract", "dictionary_entry_date", "dictionary_entry_pages", "dictionary_entry_volume", "dictionary_entry_number_of_volumes", "dictionary_entry_short_title", "dictionary_entry_series", "dictionary_entry_series_number", "dictionary_entry_publisher", "dictionary_entry_place", "dictionary_entry_language", "dictionary_entry_rights", "dictionary_entry_archive", "dictionary_entry_archive_location", "dictionary_entry_library_catalog", "dictionary_entry_call_number", "dictionary_entry_notes", "dictionary_entry_tags", "dictionary_entry_edition", "citekey"],
      end_type: "Dictionary"
    },
    encyclopedia_article: {
      category: "primary",
      csl_type: "entry-encyclopedia",
      bib_type: "misc",
      ris_type: "ENCYC",
      csv_type: "Encyclopedia Article",
      item_type: "encyclopedia_article",
      fields: ["type", "encyclopedia_article_author", "encyclopedia_article_editor", "encyclopedia_article_series_editor", "encyclopedia_article_translator", "encyclopedia_article_contributor", "encyclopedia_article_title", "encyclopedia_article_publication_title", "encyclopedia_article_isbn", "encyclopedia_article_url", "encyclopedia_article_abstract", "encyclopedia_article_date", "encyclopedia_article_pages", "encyclopedia_article_volume", "encyclopedia_article_number_of_volumes", "encyclopedia_article_short_title", "encyclopedia_article_series", "encyclopedia_article_series_number", "encyclopedia_article_publisher", "encyclopedia_article_place", "encyclopedia_article_language", "encyclopedia_article_rights", "encyclopedia_article_archive", "encyclopedia_article_archive_location", "encyclopedia_article_library_catalog", "encyclopedia_article_call_number", "encyclopedia_article_notes", "encyclopedia_article_tags", "encyclopedia_article_edition", "citekey"],
      end_type: "Encyclopedia"
    },
    manuscript: {
      category: "primary",
      csl_type: "manuscript",
      bib_type: "unpublished",
      ris_type: "MANSCPT",
      csv_type: "Manuscript",
      item_type: "manuscript",
      fields: ["type", "manuscript_author", "manuscript_translator", "manuscript_contributor", "manuscript_title", "manuscript_url", "manuscript_abstract", "manuscript_date", "manuscript_num_pages", "manuscript_short_title", "manuscript_place", "manuscript_language", "manuscript_rights", "manuscript_type", "manuscript_archive", "manuscript_archive_location", "manuscript_library_catalog", "manuscript_call_number", "manuscript_notes", "manuscript_tags", "citekey"],
      end_type: "Manuscript"
    },
    email: {
      category: "primary",
      csl_type: "personal_communication",
      bib_type: "misc",
      ris_type: "ICOMM",
      csv_type: "E-Mail",
      item_type: "email",
      fields: ["type", "email_author", "email_contributor", "email_recipient", "email_title", "email_url", "email_abstract", "email_date", "email_access_date", "email_short_title", "email_language", "email_rights", "email_notes", "email_tags", "citekey"]
    },
    instant_message: {
      category: "primary",
      csl_type: "personal_communication",
      bib_type: "misc",
      ris_type: "ICOMM",
      csv_type: "Instant Message",
      item_type: "instant_message",
      fields: ["type", "instant_message_author", "instant_message_contributor", "instant_message_recipient", "instant_message_title", "instant_message_url", "instant_message_abstract", "instant_message_date", "instant_message_short_title", "instant_message_language", "instant_message_rights", "instant_message_notes", "instant_message_tags", "citekey"]
    },
    letter: {
      category: "primary",
      csl_type: "personal_communication",
      bib_type: "misc",
      ris_type: "PCOMM",
      csv_type: "Letter",
      item_type: "letter",
      fields: ["type", "letter_author", "letter_contributor", "letter_recipient", "letter_title", "letter_url", "letter_abstract", "letter_date", "letter_access_date", "letter_short_title", "letter_language", "letter_rights", "letter_type", "letter_archive", "letter_archive_location", "letter_library_catalog", "letter_call_number", "letter_notes", "letter_tags", "citekey"]
    },
    forum_post: {
      category: "primary",
      csl_type: "post",
      bib_type: "misc",
      ris_type: "ICOMM",
      csv_type: "Forum Post",
      item_type: "forum_post",
      fields: ["type", "forum_post_author", "forum_post_contributor", "forum_post_title", "forum_post_publication_title", "forum_post_url", "forum_post_abstract", "forum_post_date", "forum_post_access_date", "forum_post_short_title", "forum_post_language", "forum_post_rights", "forum_post_type", "forum_post_notes", "forum_post_tags", "citekey"]
    },
    blog_post: {
      category: "primary",
      csl_type: "post-weblog",
      bib_type: "misc",
      ris_type: "BLOG",
      csv_type: "Blog Post",
      item_type: "blog_post",
      fields: ["type", "blog_post_author", "blog_post_contributor", "blog_post_commenter", "blog_post_title", "blog_post_publication_title", "blog_post_url", "blog_post_abstract", "blog_post_date", "blog_post_access_date", "blog_post_short_title", "blog_post_language", "blog_post_rights", "blog_post_type", "blog_post_notes", "blog_post_tags", "citekey"],
      end_type: "Blog"
    },
    artwork: {
      category: "primary",
      csl_type: "graphic",
      bib_type: "misc",
      ris_type: "ART",
      csv_type: "Artwork",
      item_type: "artwork",
      fields: ["type", "artwork_artist", "artwork_contributor", "artwork_title", "artwork_url", "artwork_abstract", "artwork_date", "artwork_access_date", "artwork_short_title", "artwork_language", "artwork_rights", "artwork_archive", "artwork_archive_location", "artwork_library_catalog", "artwork_call_number", "artwork_notes", "artwork_tags", "artwork_medium", "artwork_artwork_size", "citekey"],
      end_type: "Artwork"
    },
    audio_recording: {
      category: "primary",
      csl_type: "song",
      bib_type: "misc",
      ris_type: "SOUND",
      csv_type: "Audio Recording",
      item_type: "audio_recording",
      fields: ["type", "audio_recording_performer", "audio_recording_contributor", "audio_recording_composer", "audio_recording_words_by", "audio_recording_title", "audio_recording_isbn", "audio_recording_url", "audio_recording_abstract", "audio_recording_date", "audio_recording_access_date", "audio_recording_volume", "audio_recording_number_of_volumes", "audio_recording_short_title", "audio_recording_series_title", "audio_recording_publisher", "audio_recording_place", "audio_recording_language", "audio_recording_rights", "audio_recording_archive", "audio_recording_archive_location", "audio_recording_library_catalog", "audio_recording_call_number", "audio_recording_notes", "audio_recording_tags", "audio_recording_running_time", "audio_recording_medium", "citekey"],
      end_type: "Music"
    },
    bill: {
      category: "primary",
      csl_type: "bill",
      bib_type: "misc",
      ris_type: "BILL",
      csv_type: "Bill",
      item_type: "bill",
      fields: ["type", "bill_sponsor", "bill_contributor", "bill_cosponsor", "bill_title", "bill_url", "bill_abstract", "bill_date", "bill_access_date", "bill_pages", "bill_volume", "bill_short_title", "bill_language", "bill_rights", "bill_notes", "bill_tags", "bill_number", "bill_code", "bill_section", "bill_session", "bill_history", "bill_legislative_body", "citekey"],
      end_type: "Bill"
    },
    book: {
      category: "primary",
      csl_type: "book",
      bib_type: "book",
      ris_type: "BOOK",
      csv_type: "Book",
      item_type: "book",
      fields: ["type", "book_title", "book_author", "book_editor", "book_series_editor", "book_translator", "book_contributor", "book_isbn", "book_url", "book_abstract", "book_date", "book_access_date", "book_num_pages", "book_volume", "book_number_of_volumes", "book_short_title", "book_series", "book_series_number", "book_publisher", "book_place", "book_language", "book_rights", "book_archive", "book_archive_location", "book_library_catalog", "book_call_number", "book_notes", "book_tags", "book_edition", "book_doi", "citekey"],
      end_type: "Book"
    },
    book_section: {
      category: "primary",
      csl_type: "chapter",
      bib_type: "incollection",
      ris_type: "CHAP",
      csv_type: "Book Section",
      item_type: "book_section",
      fields: ["type", "book_section_title", "book_section_author", "book_section_editor", "book_section_series_editor", "book_section_translator", "book_section_contributor", "book_section_book_author", "book_section_publication_title", "book_section_isbn", "book_section_url", "book_section_abstract", "book_section_date", "book_section_access_date", "book_section_pages", "book_section_volume", "book_section_number_of_volumes", "book_section_short_title", "book_section_series", "book_section_series_number", "book_section_publisher", "book_section_place", "book_section_language", "book_section_rights", "book_section_archive", "book_section_archive_location", "book_section_library_catalog", "book_section_call_number", "book_section_notes", "book_section_tags", "book_section_edition", "book_section_doi", "citekey"],
      end_type: "Book Section"
    },
    "case": {
      category: "primary",
      csl_type: "legal_case",
      bib_type: "misc",
      ris_type: "CASE",
      csv_type: "Case",
      item_type: "case",
      fields: ["type", "case_author", "case_contributor", "case_counsel", "case_title", "case_url", "case_abstract", "case_date", "case_access_date", "case_pages", "case_volume", "case_short_title", "case_language", "case_rights", "case_notes", "case_tags", "case_number", "case_court", "case_reporter", "case_history", "citekey"],
      end_type: "Case"
    },
    computer_program: {
      category: "primary",
      csl_type: "book",
      bib_type: "misc",
      ris_type: "COMP",
      csv_type: "Computer Program",
      item_type: "computer_program",
      fields: ["type", "computer_program_programmer", "computer_program_contributor", "computer_program_title", "computer_program_isbn", "computer_program_url", "computer_program_abstract", "computer_program_date", "computer_program_short_title", "computer_program_series_title", "computer_program_publisher", "computer_program_place", "computer_program_rights", "computer_program_archive", "computer_program_archive_location", "computer_program_library_catalog", "computer_program_call_number", "computer_program_notes", "computer_program_tags", "computer_program_programming_language", "computer_program_version", "computer_program_system", "citekey"],
      end_type: "Computer Program"
    },
    conference_paper: {
      category: "primary",
      csl_type: "paper-conference",
      bib_type: "inproceedings",
      ris_type: "CONF",
      csv_type: "Conference Paper",
      item_type: "conference_paper",
      fields: ["type", "conference_paper_author", "conference_paper_editor", "conference_paper_contributor", "conference_paper_title", "conference_paper_proceedings_title", "conference_paper_type", "conference_paper_isbn", "conference_paper_doi", "conference_paper_url", "conference_paper_abstract", "conference_paper_date", "conference_paper_access_date", "conference_paper_pages", "conference_paper_volume", "conference_paper_short_title", "conference_paper_series", "conference_paper_publisher", "conference_paper_place", "conference_paper_language", "conference_paper_rights", "conference_paper_archive", "conference_paper_archive_location", "conference_paper_library_catalog", "conference_paper_call_number", "conference_paper_notes", "conference_paper_tags", "conference_paper_conference_name", "citekey"],
      end_type: "Conference Paper"
    },
    document: {
      category: "primary",
      csl_type: "article",
      bib_type: "misc",
      ris_type: "GEN",
      csv_type: "Document",
      item_type: "document",
      fields: ["type", "document_author", "document_editor", "document_translator", "document_contributor", "document_title", "document_url", "document_abstract", "document_date", "document_access_date", "document_short_title", "document_publisher", "document_language", "document_rights", "document_archive", "document_archive_location", "document_library_catalog", "document_call_number", "document_notes", "document_tags", "citekey"],
      end_type: "Aggregated Database"
    },
    film: {
      category: "primary",
      csl_type: "motion_picture",
      bib_type: "misc",
      ris_type: "MPCT",
      csv_type: "Film",
      item_type: "film",
      fields: ["type", "film_director", "film_contributor", "film_producer", "film_scriptwriter", "film_title", "film_url", "film_abstract", "film_date", "film_access_date", "film_short_title", "film_publisher", "film_language", "film_rights", "film_type", "film_archive", "film_archive_location", "film_library_catalog", "film_call_number", "film_notes", "film_tags", "film_running_time", "film_medium", "citekey"],
      end_type: "Film or Broadcast"
    },
    hearing: {
      category: "primary",
      csl_type: "bill",
      bib_type: "misc",
      ris_type: "HEAR",
      csv_type: "Hearing",
      item_type: "hearing",
      fields: ["type", "hearing_contributor", "hearing_title", "hearing_url", "hearing_abstract", "hearing_date", "hearing_pages", "hearing_number_of_volumes", "hearing_short_title", "hearing_publisher", "hearing_place", "hearing_language", "hearing_rights", "hearing_notes", "hearing_tags", "hearing_number", "hearing_session", "hearing_committee", "hearing_history", "hearing_legislative_body", "citekey"],
      end_type: "Hearing"
    },
    interview: {
      category: "primary",
      csl_type: "interview",
      bib_type: "misc",
      ris_type: "PCOMM",
      csv_type: "Interview",
      item_type: "interview",
      fields: ["type", "interview_interview_with", "interview_contributor", "interview_title", "interview_url", "interview_abstract", "interview_date", "interview_access_date", "interview_short_title", "interview_language", "interview_rights", "interview_archive", "interview_archive_location", "interview_library_catalog", "interview_call_number", "interview_notes", "interview_tags", "interview_medium", "citekey"],
      end_type: "Personal Communication"
    },
    article: {
      category: "primary",
      csl_type: "article-journal",
      bib_type: "article",
      ris_type: "JOUR",
      csv_type: "Journal Article",
      item_type: "article",
      fields: ["type", "article_title", "article_author", "article_journal", "article_issn", "article_doi", "article_pmid", "article_pmcid", "article_arxiv", "article_url", "article_abstract", "article_date", "article_journal_abbreviation", "article_short_title", "article_editor", "article_translator", "article_contributor", "article_reviewed_author", "article_publication_title", "article_pages", "article_issue", "article_volume", "article_series", "article_series_text", "article_language", "article_rights", "article_archive", "article_archive_location", "article_library_catalog", "article_call_number", "article_notes", "article_tags", "citekey"],
      end_type: "Electronic Article",
      is_default: true
    },
    magazine: {
      category: "primary",
      csl_type: "article-magazine",
      bib_type: "article",
      ris_type: "MGZN",
      csv_type: "Magazine",
      item_type: "magazine",
      fields: ["type", "magazine_author", "magazine_translator", "magazine_contributor", "magazine_reviewed_author", "magazine_title", "magazine_publication_title", "magazine_issn", "magazine_url", "magazine_abstract", "magazine_date", "magazine_access_date", "magazine_pages", "magazine_issue", "magazine_volume", "magazine_short_title", "magazine_language", "magazine_rights", "magazine_archive", "magazine_archive_location", "magazine_library_catalog", "magazine_call_number", "magazine_notes", "magazine_tags", "citekey"],
      end_type: "Catalog"
    },
    map: {
      category: "primary",
      csl_type: "map",
      bib_type: "misc",
      ris_type: "MAP",
      csv_type: "Map",
      item_type: "map",
      fields: ["type", "map_cartographer", "map_series_editor", "map_contributor", "map_title", "map_isbn", "map_url", "map_abstract", "map_date", "map_access_date", "map_short_title", "map_series_title", "map_publisher", "map_place", "map_language", "map_rights", "map_type", "map_archive", "map_archive_location", "map_library_catalog", "map_call_number", "map_notes", "map_tags", "map_edition", "map_scale", "citekey"],
      end_type: "Map"
    },
    newspaper_article: {
      category: "primary",
      csl_type: "article-newspaper",
      bib_type: "article",
      ris_type: "NEWS",
      csv_type: "Newspaper Article",
      item_type: "newspaper_article",
      fields: ["type", "newspaper_article_author", "newspaper_article_translator", "newspaper_article_contributor", "newspaper_article_reviewed_author", "newspaper_article_title", "newspaper_article_publication_title", "newspaper_article_issn", "newspaper_article_url", "newspaper_article_abstract", "newspaper_article_date", "newspaper_article_pages", "newspaper_article_short_title", "newspaper_article_place", "newspaper_article_language", "newspaper_article_rights", "newspaper_article_archive", "newspaper_article_archive_location", "newspaper_article_library_catalog", "newspaper_article_call_number", "newspaper_article_notes", "newspaper_article_tags", "newspaper_article_edition", "newspaper_article_section", "citekey"],
      end_type: "Newspaper Article"
    },
    patent: {
      category: "primary",
      csl_type: "patent",
      bib_type: "patent",
      ris_type: "PAT",
      csv_type: "Patent",
      item_type: "patent",
      fields: ["type", "patent_title", "patent_inventor", "patent_contributor", "patent_patent_id", "patent_application_number", "patent_guest", "patent_attorney_agent", "patent_url", "patent_abstract", "patent_date", "patent_access_date", "patent_pages", "patent_short_title", "patent_place", "patent_language", "patent_rights", "patent_notes", "patent_tags", "patent_number", "patent_filing_date", "patent_publication_date", "patent_assignee", "patent_issuing_authority", "patent_country", "patent_references", "patent_legal_status", "patent_priority_numbers", "citekey"],
      end_type: "Patent"
    },
    podcast: {
      category: "primary",
      csl_type: "broadcast",
      bib_type: "misc",
      ris_type: "SOUND",
      csv_type: "Podcast",
      item_type: "podcast",
      fields: ["type", "podcast_podcaster", "podcast_title", "podcast_url", "podcast_abstract", "podcast_access_date", "podcast_short_title", "podcast_series_title", "podcast_language", "podcast_rights", "podcast_notes", "podcast_tags", "podcast_number", "podcast_running_time", "podcast_medium", "citekey"]
    },
    presentation: {
      category: "primary",
      csl_type: "speech",
      bib_type: "misc",
      ris_type: "SLIDE",
      csv_type: "Presentation",
      item_type: "presentation",
      fields: ["type", "presentation_presenter", "presentation_contributor", "presentation_title", "presentation_url", "presentation_abstract", "presentation_date", "presentation_access_date", "presentation_short_title", "presentation_place", "presentation_language", "presentation_rights", "presentation_type", "presentation_notes", "presentation_tags", "presentation_meeting_name", "citekey"]
    },
    report: {
      category: "primary",
      csl_type: "report",
      bib_type: "techreport",
      ris_type: "RPRT",
      csv_type: "Report",
      item_type: "report",
      fields: ["type", "report_author", "report_series_editor", "report_contributor", "report_title", "report_url", "report_access_date", "report_abstract", "report_date", "report_pages", "report_short_title", "report_series_title", "report_publisher", "report_place", "report_language", "report_rights", "report_type", "report_archive", "report_archive_location", "report_library_catalog", "report_call_number", "report_notes", "report_tags", "report_number", "citekey"],
      end_type: "Government Document"
    },
    statute: {
      category: "primary",
      csl_type: "legislation",
      bib_type: "misc",
      ris_type: "STAT",
      csv_type: "Statute",
      item_type: "statute",
      fields: ["type", "statute_author", "statute_contributor", "statute_title", "statute_url", "statute_abstract", "statute_date", "statute_access_date", "statute_pages", "statute_short_title", "statute_language", "statute_rights", "statute_notes", "statute_tags", "statute_number", "statute_code", "statute_code_number", "statute_section", "statute_session", "statute_history", "citekey"],
      end_type: "Statute"
    },
    thesis: {
      category: "primary",
      csl_type: "thesis",
      bib_type: "phdthesis",
      ris_type: "THES",
      csv_type: "Thesis",
      item_type: "thesis",
      fields: ["type", "thesis_title", "thesis_author", "thesis_contributor", "thesis_abstract", "thesis_tags", "thesis_date", "thesis_publisher", "thesis_notes", "citekey"],
      end_type: "Thesis"
    },
    tv_broadcast: {
      category: "primary",
      csl_type: "broadcast",
      bib_type: "misc",
      ris_type: "MPCT",
      csv_type: "TV Broadcast",
      item_type: "tv_broadcast",
      fields: ["type", "tv_broadcast_director", "tv_broadcast_cast_member", "tv_broadcast_producer", "tv_broadcast_scriptwriter", "tv_broadcast_guest", "tv_broadcast_title", "tv_broadcast_publication_title", "tv_broadcast_url", "tv_broadcast_abstract", "tv_broadcast_date", "tv_broadcast_access_date", "tv_broadcast_short_title", "tv_broadcast_publisher", "tv_broadcast_place", "tv_broadcast_language", "tv_broadcast_rights", "tv_broadcast_archive", "tv_broadcast_archive_location", "tv_broadcast_library_catalog", "tv_broadcast_call_number", "tv_broadcast_notes", "tv_broadcast_tags", "tv_broadcast_number", "tv_broadcast_running_time", "tv_broadcast_medium", "citekey"]
    },
    video_recording: {
      category: "primary",
      csl_type: "motion_picture",
      bib_type: "misc",
      ris_type: "VIDEO",
      csv_type: "Video Recording",
      item_type: "video_recording",
      fields: ["type", "video_recording_director", "video_recording_contributor", "video_recording_cast_member", "video_recording_producer", "video_recording_scriptwriter", "video_recording_title", "video_recording_isbn", "video_recording_url", "video_recording_abstract", "video_recording_date", "video_recording_access_date", "video_recording_volume", "video_recording_number_of_volumes", "video_recording_short_title", "video_recording_series_title", "video_recording_publisher", "video_recording_place", "video_recording_language", "video_recording_rights", "video_recording_archive", "video_recording_archive_location", "video_recording_library_catalog", "video_recording_call_number", "video_recording_notes", "video_recording_tags", "video_recording_running_time", "video_recording_medium", "citekey"],
      end_type: "Audiovisual Material"
    },
    webpage: {
      category: "primary",
      csl_type: "webpage",
      bib_type: "misc",
      ris_type: "ELEC",
      csv_type: "Web Page",
      item_type: "webpage",
      fields: ["type", "webpage_title", "webpage_author", "webpage_url", "webpage_access_date", "webpage_translator", "webpage_contributor", "webpage_publication_title", "webpage_abstract", "webpage_date", "webpage_short_title", "webpage_language", "webpage_rights", "webpage_type", "webpage_notes", "webpage_tags", "citekey"],
      end_type: "Web Page"
    },
    abstract: {
      category: "primary",
      csl_type: "paper-conference",
      bib_type: "misc",
      ris_type: "ABST",
      csv_type: "Abstract",
      item_type: "abstract",
      fields: ["type", "abstract_author", "abstract_editor", "abstract_contributor", "abstract_title", "abstract_proceedings_title", "abstract_type", "abstract_isbn", "abstract_doi", "abstract_url", "abstract_abstract", "abstract_date", "abstract_access_date", "abstract_pages", "abstract_volume", "abstract_short_title", "abstract_series", "abstract_publisher", "abstract_place", "abstract_language", "abstract_rights", "abstract_archive", "abstract_archive_location", "abstract_library_catalog", "abstract_call_number", "abstract_notes", "abstract_tags", "abstract_conference_name", "citekey"]
    },
    poster: {
      category: "primary",
      csl_type: "speech",
      bib_type: "misc",
      ris_type: "SLIDE",
      csv_type: "Poster",
      item_type: "poster",
      fields: ["type", "poster_presenter", "poster_contributor", "poster_title", "poster_url", "poster_abstract", "poster_date", "poster_access_date", "poster_short_title", "poster_place", "poster_language", "poster_rights", "poster_type", "poster_notes", "poster_tags", "poster_meeting_name", "citekey"]
    }
  },
  papermill_sources: {
    "$.submission_date": {
      data_type: "papers_99_date"
    },
    "$.revision_date": {
      data_type: "papers_99_date"
    },
    "$.accepted_date": {
      data_type: "papers_99_date"
    },
    "$.publication_date": {
      data_type: "papers_99_date"
    },
    "$.read_status": {
      data_type: "papers_int_boolean"
    },
    "$.matched": {
      data_type: "papers_simple_int_boolean"
    },
    "$.printed_date": {
      data_type: "papers_timestamp_boolean"
    },
    "$.full_editor_string": {
      data_type: "papers_and_delimited_string"
    },
    "$.full_author_string": {
      data_type: "papers_and_delimited_string"
    },
    "$.full_translator_string": {
      data_type: "papers_and_delimited_string"
    },
    "$.authors[*].fullname": {
      data_type: "array"
    },
    "$.imported_date": {
      data_type: "papers_timestamp"
    }
  },
  nonuser: ["imported", "times_read"]
};

var _require = require("./mappers"),
    mappers = _require.mappers,
    complexFieldsMap = _require.complexFieldsMap,
    dateMapper = _require.dateMapper;

var defaultDbg = function defaultDbg() {
  return null;
};

var get = function get(obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
};

var last = function last(array) {
  return array[array.length - 1];
};

var lastFieldPart = function lastFieldPart(field) {
  if (!field) return;
  var parts = field.split(".");
  return last(parts);
};

var fieldAsCslField = function fieldAsCslField(field, item, mapping, debug) {
  var _item$import_data;

  var isJanssen = (item === null || item === void 0 ? void 0 : (_item$import_data = item.import_data) === null || _item$import_data === void 0 ? void 0 : _item$import_data.source) === "janssen_endnote";
  var fieldDef = mapping.field_defs[field];
  var cslField = fieldDef && fieldDef.csl || lastFieldPart(fieldDef.readcube || fieldDef.custom_metadata);
  var cslValue = get(item, fieldDef.readcube || "custom_metadata.".concat(fieldDef.custom_metadata));
  var complexFieldType = complexFieldsMap[cslField];

  if (cslValue && complexFieldType) {
    var mapper = mappers[complexFieldType];
    var isCustomMetadata = !!fieldDef.custom_metadata;
    cslValue = mapper(isJanssen, isCustomMetadata, cslValue);
  }

  if (fieldDef.custom_metadata === "date" && cslValue == null) {
    var year = get(item, "article.year");
    if (year != null) cslValue = {
      'date-parts': [[year + '']]
    };
  }

  if (cslField === 'container-title') cslValue = cslValue != null && '' + cslValue;
  debug("".concat(field, " -> \n\t").concat(cslField, ":").concat(JSON.stringify(cslValue)));
  return {
    cslField: cslField,
    cslValue: cslValue
  };
};

var customFieldAsCslField = function customFieldAsCslField(customField, item, debug) {
  var directCustomFieldType = ['lookup', 'bool', 'number', 'array', 'textarea', 'text'];
  var dateCustomFieldType = ['date'];

  if (directCustomFieldType.includes(customField.type)) {
    var cslField = customField.field;
    var cslValue = item.custom_metadata[cslField];
    return {
      cslField: cslField,
      cslValue: cslValue
    };
  }

  if (dateCustomFieldType.includes(customField.type)) {
    var _cslField = customField.field;
    var customMetadataValue = item.custom_metadata[_cslField];

    var _cslValue = dateMapper(null, null, customMetadataValue);

    return {
      cslField: _cslField,
      cslValue: _cslValue
    };
  }

  debug("Unknown custom field.");
  return {
    cslField: null,
    cslValue: null
  };
};

var asCiteprocItem = function asCiteprocItem(_ref) {
  var _Object$entries$find;

  var item = _ref.item,
      customSchema = _ref.customSchema,
      _ref$customFields = _ref.customFields,
      customFields = _ref$customFields === void 0 ? [] : _ref$customFields,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? defaultDbg : _ref$debug;
  var mapping = customSchema || meta;
  var defaultTypeName = (_Object$entries$find = Object.entries(mapping.types).find(function (entry) {
    var _entry = _slicedToArray(entry, 2),
        typeName = _entry[0],
        typeDef = _entry[1];

    return typeDef.is_default === true;
  })) === null || _Object$entries$find === void 0 ? void 0 : _Object$entries$find[0];
  var type = item.item_type || defaultTypeName;
  if (customSchema && item.custom_type) type = item.custom_type;
  var typeDef = mapping.types[type] || mapping.types[defaultTypeName];
  var fields = typeDef.fields;
  var cslItem = fields.reduce(function (cslObject, field) {
    var _fieldAsCslField = fieldAsCslField(field, item, mapping, debug),
        cslField = _fieldAsCslField.cslField,
        cslValue = _fieldAsCslField.cslValue;

    if (cslField && cslValue) cslObject[cslField] = cslValue;
    return cslObject;
  }, {});
  (customFields || []).forEach(function (customField) {
    var _customFieldAsCslFiel = customFieldAsCslField(customField, item, debug),
        cslField = _customFieldAsCslFiel.cslField,
        cslValue = _customFieldAsCslFiel.cslValue;

    if (cslField && cslValue != null) cslItem[cslField] = cslValue;
  });
  cslItem["id"] = item.id;
  cslItem["type"] = typeDef.csl_type || type;

  if (item.custom_metadata && item.custom_metadata.rtyp != null) {
    var rtypVal = item.custom_metadata.rtyp;
    cslItem['rtyp_' + rtypVal] = rtypVal;
  }

  return cslItem;
};

var asPlaceholderText = function asPlaceholderText(_ref2) {
  var item = _ref2.item,
      _ref2$debug = _ref2.debug,
      debug = _ref2$debug === void 0 ? defaultDbg : _ref2$debug;
  var citekey = item.user_data && item.user_data.citekey;
  if (citekey) return citekey;
  var title = item.article.title;
  var year = item.article.year;
  var authors = item.article.authors;
  var doi = item.ext_ids.doi;
  var pmid = item.ext_ids.pmid;

  if (authors && authors.length) {
    var firstAuthorsLastname = last(authors[0].split(" "));
    var authorText = authors.length > 1 ? firstAuthorsLastname + " et al." : firstAuthorsLastname;
    return year ? authorText + ", " + year : authorText;
  }

  if (title && title.length) {
    var shortTitle = title.length > 24 ? '"' + title.substring(0, 24) + '..."' : '"' + title + '"';
    return year ? shortTitle + ", " + year : shortTitle;
  }

  if (doi) return "doi:" + doi;
  if (pmid) return "pmid:" + pmid;
  return "Untitled Citation";
};

module.exports = {
  asCiteprocItem: asCiteprocItem,
  asPlaceholderText: asPlaceholderText
};